// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyA5rLTs8rLa0hW3ecvUw_EBvfmic4zdxKg",
  authDomain: "wholesale-4skin.firebaseapp.com",
  projectId: "wholesale-4skin",
  storageBucket: "wholesale-4skin.firebasestorage.app",
  messagingSenderId: "555630267045",
  appId: "1:555630267045:web:91bc1529582234c4c91b4c"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;
